export const initialState: {
  isLoading: boolean;
  isAuth: boolean;
  passwordVisible: boolean;
  error: {
    email: string;
    password: string;
  };
  email: string;
  password: string;
  rememberChecked: boolean;
} = {
  isLoading: false,
  passwordVisible: false,
  isAuth: false,
  error: {
    email: "",
    password: "",
  },
  email: "",
  password: "",
  rememberChecked: false,
};
